<template>
  <div>
    <article
      v-if="!collapsed"
      :class="['relative rounded-2xl border border-gray-200 px-7 py-5 bg-white shadow-lg', cardClass]"
    >
      <div :class="headerClass">
        <div v-if="showTitle || subtitle || $slots['title-append']" :class="titleWrapperClass">
          <div class="flex items-center gap-2 flex-wrap">
            <h3 v-if="showTitle" class="text-xl font-semibold text-gray-900">{{ title }}</h3>
            <slot name="title-append" />
          </div>
          <p v-if="subtitle" class="text-sm text-gray-500">{{ subtitle }}</p>
        </div>
        <div :class="actionsClass">
          <slot name="header-actions" />
          <!--
          <button
            type="button"
            class="absolute top-0 right-0 inline-flex h-9 w-9 items-center justify-center rounded-2xl text-sm text-gray-500 hover:text-primary-600 focus:text-primary-600 focus:outline-none transition"
            :aria-expanded="(!collapsed).toString()"
            @click="$emit('toggle')"
          >
            <i class="fas fa-compress-alt"></i>
          </button>
          -->
          <slot name="header-actions-after" />
        </div>
      </div>
      <div :class="contentClass">
        <slot />
      </div>
    </article>
    <button
      v-else
      type="button"
      class="group flex w-full items-center justify-between gap-4 rounded-2xl border border-blue-200 bg-white px-4 py-3.5 text-left transition hover:-translate-y-px"
      :aria-label="showTitle ? null : title"
      @click="$emit('toggle')"
    >
      <div class="flex items-center gap-3">
        <slot name="collapsed-leading">
          <i v-if="collapsedIcon" :class="collapsedIcon"></i>
        </slot>
        <div :class="collapsedTextClass">
          <p v-if="showTitle" class="dashboard-card-title text-sm font-semibold text-gray-900">{{ title }}</p>
          <slot name="collapsed-description">
            <p v-if="collapsedSubtitle" class="text-xs text-gray-600">{{ collapsedSubtitle }}</p>
          </slot>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'DashboardCollapsibleCard',
  props: {
    title: {
      type: String,
      required: true
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    collapsedSubtitle: {
      type: String,
      default: ''
    },
    collapsed: {
      type: Boolean,
      required: true
    },
    collapsedIcon: {
      type: String,
      default: ''
    },
    cardClass: {
      type: String,
      default: ''
    },
    headerClass: {
      type: String,
      default: 'flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'
    },
    titleWrapperClass: {
      type: String,
      default: ''
    },
    actionsClass: {
      type: String,
      default: 'flex items-center gap-2'
    },
    contentClass: {
      type: String,
      default: 'mt-4'
    },
    collapsedTextClass: {
      type: String,
      default: ''
    }
  }
}
</script>
